/**
 * Parse and format datetimes stored by D1/SQLite.
 * SQLite datetime('now') returns "YYYY-MM-DD HH:MM:SS" in UTC without a suffix.
 */

import { format, isValid, parseISO } from 'date-fns'

export function parseDbDateTime(value) {
  if (!value) return null
  const s = String(value).trim()

  // Already includes timezone (Z or +/- offset) — parse as-is.
  if (/[zZ]$/.test(s) || /[+-]\d{2}:\d{2}$/.test(s)) {
    const d = parseISO(s)
    return isValid(d) ? d : null
  }

  // D1/SQLite UTC datetime without timezone suffix (space or T separator).
  const normalized = s.replace(' ', 'T')
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(normalized)) {
    const d = new Date(`${normalized}Z`)
    return isValid(d) ? d : null
  }

  const d = parseISO(s)
  return isValid(d) ? d : null
}

export function formatDbDateTime(value, { fallback = '—', dateStyle } = {}) {
  const d = parseDbDateTime(value)
  if (!d) return fallback

  if (dateStyle) {
    return d.toLocaleString(undefined, dateStyle)
  }

  return d.toLocaleString()
}

export function formatDbDateTimeShort(value, { fallback = 'N/A' } = {}) {
  const d = parseDbDateTime(value)
  if (!d) return fallback
  return format(d, 'MMM d, yyyy h:mm a')
}
